@if (facade.derivativeProductDescription$ | async; as descr) {
  <div class="tile" data-zid="product-description-tile">
    <h5 class="mb-3">{{ 'instrument-detail.derivative-product-description.headline' | transloco }}</h5>
    <div class="zero-text p-small-reg" data-zid="product-description">{{ descr }}</div>
  </div>
}
